<template>
    <div class="form-box">
        <div class="form-right from7-r">
            <div style="width:100%;height:6vh;padding-left:1vw;background:#fff;display:flex;align-items: center;border-bottom: 5px solid #ecf0f5;">
                <el-page-header @back="goBack" content="检查记录"></el-page-header>
            </div>
            <div style="width:100%;height:calc( 100% - 11vh );position: relative;padding:1vh;background:#fff;overflow: auto;">
                <div class="table-item" v-for="(item,index) in tableData" :key="index">
                    <div class="item-l">
                        <img :src="item.pic" style="width:100%;height:100%;" />
                    </div>
                    <div class="item-mid">
                        <p>检查事项：</p>
                        <p class="line2" style="height:6vh;" :title="item.description">{{item.description}}</p>
                        <p>检查人：{{item.reportName}}</p>
                        <p>检查时间：{{item.happenDate}}</p>
                    </div>
                    <div class="item-mid">
                        <p class="nowrap" :title="item.processDesc">检查结果：<span v-if="item.checkResult=='无'" style="color:#F7904A;">{{item.checkResult||'--'}}</span><span v-else style="color:red;">{{item.checkResult||'--'}}</span></p>
                        <p>责任人：{{item.handlerName ||'--'}}</p>
                        <p class="nowrap" :title="item.processDesc">处理信息：{{item.checkStatus || '--'}}</p>
                        <!-- <p class="nowrap" :title="item.processDesc">处理状态：{{item.processDesc || '--'}}</p> -->
                        <p>确认人：{{item.affirm || '--'}}</p>
                        <p>确认状态：{{item.affirmStatus || '--'}}</p>
                    </div>
                    <div class="item-r">
                        <el-button type="text" @click="toDetail(item)">详情</el-button>
                        <el-button type="text" @click="toDownFile(item)" style="color:#67C23A;">导出</el-button>
                    </div>
                </div>
                <div v-if="tableData.length==0" style="width:100%;height:100%;position: relative;display: flex;align-items: center;justify-content: center;">
                    {{dataText}}
                </div>
            </div>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 20, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalItems"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import base from '../../../untils/base'
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
export default {
    data(){
        return{
            groupId:'',
            planId:'',
            dataTree:[],
            defaultProps: {
                children: 'list',
                label: 'name'
            },
            projectId:'',//当前项目id
            currentNodekey:'',//当前树形选中值
            expandedkeys:[],//树形展开值
            dataText: '数据加载中...',
            tableData:[],
            curId:0,
            //分页
            currentPage:1,
            pageSize:10,
            totalItems:0,
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        var params = this.$route.params
        this.planId = params.id
        this.getData()
    },
    methods:{
        handleSizeChange(val){
            this.pageSize = val
            this.handleCurrentChange(this.currentPage)
        },
        handleCurrentChange(val){
            this.currentPage = val
            this.currentChangePage();
        },
        currentChangePage() {
            this.getData();
        },
        //获取数据
        getData(){
            var that = this
            this.tableData = []
            myHttp.getQsInfoById({
                id:this.planId,
                flag:'1'
            }).then(function(resp){
                console.log(resp)
                if(resp.data.code=='200'){
                    var list = resp.data.data.qsList.list||[]
                    for(var i=0;i<list.length;i++){
                        list[i].pic = list[i].picUrls && list[i].picUrls!=''?base.httpCtx+(list[i].picUrls.split(',')[0]):require('../../../assets/image/project.png')
                    }
                    that.tableData = list
                    if(list.length==0){
                        that.dataText = '暂无数据'
                    }
                }else{
                    that.dataText = '暂无数据'
                }
            })
        },
        /**
         * 详情
         */
        toDetail(row){
            this.$router.push({ name: 'qsDetail', params: { id: row.qsId ,type:row.type,handle:'1'} })
        },
        /**
         * 下载
         */
        toDownFile(row){
            var token = util.session.get('token')
            window.open(
                myHttp.exportQsInfo +
                '?id=' +
                row.qsId +
                '&accessToken=' +
                token
            )
        },

        //返回
        goBack(){
            this.$router.go(-1)
        },
    }
}
</script>

<style scoped>
    .form-box{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        padding: 1vh;
    }
    .form-left{
        width:15vw;
        height: 100%;
        position: relative;
        background: #fff;
        padding: 1vh;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        align-items: flex-start;
    }
    .form-left .on{
        color: #2447D7;
    }
    .form-right{
        width: 100%;
        height: 100%;
        position: relative;
        padding-left: 1vh;
    }
    .table-item{
        width: 100%;
        height: 19vh;
        position: relative;
        display: flex;
        padding: 1vh;
        border-bottom: 1vh solid #ecf0f5;
    }
    .table-item .item-l{
        width: 11vw;
        height: 100%;
        position: relative;
    }
    .table-item .item-r{
        width: 5vh;
        height: 100%;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        padding: 1vw;
    }
    .table-item .item-mid{
        width: calc( 50% - 8vw );
        height: 100%;
        position: relative;
        justify-content: flex-start;
        display: flex;
        flex-wrap: wrap;
        padding-left: 1vw;
    }
    .table-item .item-mid p{
        width: 100%;
        height: 3vh;
        position: relative;
        text-align: left;
        line-height: 3vh;
        color: #737477;
    }
</style>

<style>
    @import '../../../assets/css/common.css';
    .el-table--border th, .el-table__fixed-right-patch{
        border-bottom: 1px solid #303133;
    }
    .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 1px solid #303133;
    }
    .el-table td, .el-table th.is-leaf{
        border-bottom: 1px solid #303133;
    }
    .el-table--border, .el-table--group{
        border: 1px solid #303133;
    }
    .from7-r .el-table--border th:nth-child(3),.from7-r .el-table--border td:nth-child(3){
        border-right: 1px solid #dddddd;
    }
    .from7-r .el-table--border th:nth-child(5),.from7-r .el-table--border td:nth-child(5){
        border-right: 1px solid #dddddd;
    }
</style>